import React from 'react';
import tpl from '../templates/aexpress.jsx';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';
import AExpressModel from '../../../Models/aexpress.m';
import {apiback} from '../../../../../config';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            model: {},
            search_by: ['/business/a-express'],
            mode: 'a-express-standard',
            tab: 'tariffs-standard'
        };

        this.toggleMode = this.toggleMode.bind(this);
    }

    componentWillMount() {
        document.addEventListener('switchCalcMode', this.toggleMode);
        fetch(apiback('AEXPRESS_CALC'))
            .then(res => res.json())
            .then(json => {
                const list = Object.keys(json.data);
                const model = new AExpressModel(json.data, list, this.state.mode);

                this.setState({
                    model: model
                });
            })
            .then(this.scrollToCalculator);
    }

    toggleMode(event) {
        const {mode} = event.detail;

        this.setState({mode});

        this.state.model.changeField('currentName', mode);
        if (mode === 'a-express-collateral') {
            this.state.model.changeField('creditSum', '1000000');
            this.state.model.changeField('loanTerm', '30');
        }
    }

    componentWillUnmount() {
        document.removeEventListener('switchCalcMode', this.toggleMode);
    }

    scrollToCalculator = () => {
        const {pathname} = window.location;

        if (!pathname.endsWith('/calc')) return;

        this.waitForElement('.calculator-new', element => {
            element.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            });
        });
    };

    static displayName = 'Business.Views.Aexpress';
}
